import { CvlApplicationStatusEnumType } from '__generated__/graphql';

export default function cvlApplicationStatusToReadable(status: CvlApplicationStatusEnumType): {
  label: string;
  color: string;
} {
  switch (status) {
    case CvlApplicationStatusEnumType.Registered:
      return {
        label: 'Registered',
        color: 'gray',
      };
    case CvlApplicationStatusEnumType.ApplicationDraft:
      return {
        label: 'Draft',
        color: 'amber',
      };
    case CvlApplicationStatusEnumType.ApplicationSubmitted:
      return {
        label: 'Submitted',
        color: 'orange',
      };
    case CvlApplicationStatusEnumType.ApplicationVerified:
      return {
        label: 'Verified',
        color: 'blue',
      };
    case CvlApplicationStatusEnumType.ApplicationApproved:
      return {
        label: 'Approved',
        color: 'green',
      };
    case CvlApplicationStatusEnumType.ApplicationRejected:
      return {
        label: 'Rejected',
        color: 'red',
      };
    default:
      return {
        label: status,
        color: 'gray',
      };
  }
}
